import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import School from "../../assets/ShreeSchool.jpeg";
import PageTitle from "../../Components/PageTitle";

const About = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="About Shree Mangalam School"
        description="Learn about Shree Mangalam School – a premier coaching institute preparing students for RIMC, Sainik School, and Military School exams with academic excellence and discipline."
        url="/about-school"
        keywords="about Shree Manglam, school overview, RIMC coaching, Sainik School institute, military school preparation, best coaching in Jaipur"
      />

      <Header image={School} alt={"Shree Mangalam School"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Welcome to Shree Mangalam School
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Welcome to Shree Mangalam School, Jaipur-Gudha State Highway (Just on by pass) In Gudha Gorji — the latest beacon of educational
          excellence in the region. As a proud addition to Jhunjhunu’s growing
          reputation for quality education, our school represents a commitment
          to nurturing young minds through a blend of tradition, innovation, and
          a passion for learning.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we are dedicated to providing exceptional
          educational opportunities to students in jaipur-gudha state highway (Just on by pass) gudha gorji, and
          nearby areas. Backed by a team of visionary educators and driven by a
          mission to make world-class education accessible in rural and
          semi-urban regions, we aim to set new benchmarks in academic and
          personal development.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Our school is founded on a philosophy that values both academic rigor
          and holistic growth. Alongside a robust curriculum designed to foster
          critical thinking, creativity, and curiosity, we focus on the
          physical, emotional, and ethical development of each student. Our
          faculty is passionate about guiding every learner with care,
          expertise, and commitment.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          In addition to a comprehensive academic framework, Shree Mangalam School offers specialized coaching for competitive
          entrance examinations such as Jawahar Navodaya Vidyalaya (JNV),
          Rashtriya Indian Military College (RIMC), Sainik Schools, and Military
          Schools. With structured learning modules, personalized support, and
          regular assessments, we equip students with the knowledge and
          confidence to succeed in highly competitive environments.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We believe in the power of a well-rounded education. Our campus is
          equipped with modern classrooms, smart learning tools, and facilities
          that support sports, arts, and extracurricular activities. These
          experiences not only enhance learning but also help students discover
          their strengths, passions, and leadership potential.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Shree Mangalam School is more than just a school — it is a vibrant
          community where students, parents, teachers, and staff come together
          with shared goals and mutual respect. We emphasize values like
          integrity, responsibility, empathy, and discipline, ensuring that our
          students grow into thoughtful and responsible citizens of tomorrow.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          As we continue our journey, Shree Mangalam School is
          poised to become a center of excellence — inspiring minds, shaping
          futures, and contributing meaningfully to society. We invite you to be
          a part of this exciting journey, where every student’s dream is
          nurtured and every achievement is celebrated.
        </Typography>
      </Container>

      <Footer />
    </>
  );
};

export default About;
